import LightboxImage from "../../../../src/components/mdx/lightbox-image/LightboxImage";
import SideBySideImages from "../../../../src/components/mdx/side-by-side-images/SideBySideImages";
import * as React from 'react';
export default {
  LightboxImage,
  SideBySideImages,
  React
};